import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Menu } from '@app/models/menu/menu.model';
import { MenuItem } from '@app/models/menu/menuitem.model';
import { MenuItemType } from '@app/models/menu/menuitem.type.enum';
import { MenuItemOrder } from '@app/models/menu/menuitemorder.model';
import { FunctionSummaryModel } from '@app/models/functioninfo/functionSummary.model';

@Injectable()
export class MenuAdminService {
    private service = 'api/menuservice';
    public menuIconFileUploadService = this.service + '/upload'

    public menuUpdated = new Subject();
    public userMenuChanged = new Subject();

    private userMenu: Menu = null;

    constructor(private httpClient: HttpClient) {
    }

    public clearMenu() {
        this.userMenu = null;
    }

    public getUserMenu( fromRemote: boolean = false): Observable<Menu> {
        if (this.userMenu && fromRemote == false) {
            return new Observable((observer) => {
                observer.next(this.userMenu);
            });
        } else {
            return new Observable((observer) => {
                this.httpClient.get<Menu>(`${this.service}/getUserMenu`)
                    .subscribe(
                        result => {
                            this.userMenu = result;
                            observer.next(result);
                            this.userMenuChanged.next(result);
                        },
                        error => observer.error(error),
                        () => observer.complete());
            });
        }
    }

    public getAllMenu(): Observable<Menu> {
        return this.httpClient.get<Menu>(`${this.service}/getAllMenu`);
    }

    public deleteMenuItem(itemId: number): Observable<any> {
        return this.httpClient.delete<any>(`${this.service}/deleteMenuItem/${itemId}`, { responseType: "json" });
    }

    public updateMenuItem(menuItem: MenuItem) {
        return this.httpClient.post<MenuItem>(`${this.service}/updateMenuItem`, menuItem);
    }

    public addMenuItem(menuItem: MenuItem): Observable<MenuItem> {
        return this.httpClient.post<MenuItem>(`${this.service}/addMenuItem`, menuItem);
    }

    public updateItemOrders(itemOrderList: MenuItemOrder[]) {
        let jsonData = JSON.stringify(itemOrderList);
        return this.httpClient.post(`${this.service}/updateMenuItemOrders`, jsonData);
    }

    public createDefaultMenuItem(displayText: string, type: MenuItemType): MenuItem {
        let menuItem = new MenuItem();
        menuItem.menuItemType = type;
        menuItem.displayText = displayText;
        menuItem.itemOrder = 0;
        return menuItem;
    }

    public getMenuFunctionByRoute(route: string): FunctionSummaryModel {

        let functionModel = null;
        if (this.userMenu) {
            this.userMenu.separatorItems.forEach(sep => {
                sep.childItems.forEach(mi => {
                    if (mi.menuItemType === MenuItemType.Group) {
                        if (mi.childItems && mi.childItems.length > 0) {
                            mi.childItems.forEach(i => {
                                if (i.functionViewModel && i.functionViewModel.routePath.toLowerCase() === route.toLowerCase()) {
                                    functionModel = i.functionViewModel;
                                    return;
                                }
                            });
                        }
                    } else {
                        if (mi.functionViewModel && mi.functionViewModel.routePath.toLowerCase() === route.toLowerCase()) {
                            functionModel = mi.functionViewModel;
                            return;
                        }
                    }
                });
            });
        }
        return functionModel;


    }
}
